import {
    connectE7Robot
} from '../get-Link-fn.js';
// 打开程序后默认显示的机器人
function DefaultRobot(translator, messages) {


    const arrayRobot = getRobotData(translator, messages)

    //获取默认机器人类型，没有则为‘E6’
    let robotType = localStorage.getItem('default_robot') ? localStorage.getItem('default_robot') : 'E6';

    if (robotType == "E7") {
        connectE7Robot()
    }

    return arrayRobot[robotType] || arrayRobot['E6']

}


function getRobotData(translator, messages) {
    return {
        E6: {
            isStage: false,
            isRobot: true,
            robotType: 'E6',
            name: translator(messages.E6, {
                index: 1
            }),
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            costumes: [{
                assetId: '3696356a03a8d93831bb76a593515243',
                name: translator(messages.costume, {
                    index: 1
                }),
                bitmapResolution: 1,
                md5ext: '3696356a03a8d93831bb76a593515243.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: translator(messages.meow),
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 100,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        },
        C1: {
            isStage: false,
            isRobot: true,
            robotType: 'C1',
            name: translator(messages.C1, {
                index: 1
            }),
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            costumes: [{
                assetId: '3696356a03a8d93831ab76a593515244',
                name: translator(messages.costume, {
                    index: 1
                }),
                bitmapResolution: 1,
                md5ext: '3696356a03a8d93831ab76a593515244.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: translator(messages.meow),
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 50,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        },
        E3: {
            isStage: false,
            isRobot: true,
            robotType: 'E3',
            name: translator(messages.E3, {
                index: 1
            }),
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            costumes: [{
                assetId: '3696356a03a8d93831ab76a593515246',
                name: translator(messages.costume, {
                    index: 1
                }),
                bitmapResolution: 1,
                md5ext: '3696356a03a8d93831ab76a593515246.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: translator(messages.meow),
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 50,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        },
        M6: {
            isStage: false,
            isRobot: true,
            robotType: 'M6',
            name: translator(messages.M6, {
                index: 1
            }),
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            costumes: [{
                assetId: '9696356a03a8d93831ab76a593515247',
                name: translator(messages.costume, {
                    index: 1
                }),
                bitmapResolution: 1,
                md5ext: '9696356a03a8d93831ab76a593515247.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: translator(messages.meow),
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 100,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        },
        A2: {
            isStage: false,
            isRobot: true,
            robotType: 'A2',
            name: translator(messages.A2, {
                index: 1
            }),
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            costumes: [{
                assetId: '3696356a03a8d93831ab76a593515243',
                name: translator(messages.costume, {
                    index: 1
                }),
                bitmapResolution: 1,
                md5ext: '3696356a03a8d93831ab76a593515243.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: translator(messages.meow),
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 100,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        },
        E7: {
            isStage: false,
            isRobot: true,
            robotType: 'E7',
            name: 'H-RCU',
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            costumes: [{
                assetId: '3696356a03a8d93831ab76a593515245',
                name: translator(messages.costume, {
                    index: 1
                }),
                bitmapResolution: 1,
                md5ext: '3696356a03a8d93831ab76a593515245.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: translator(messages.meow),
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 100,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        },
        STORM_OS: {
            isStage: false,
            isRobot: true,
            robotType: 'STORM_OS',
            name: 'SenseStorm3',
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            costumes: [{
                assetId: '3696356a03a8d93831ab76a593515255',
                name: translator(messages.costume, {
                    index: 1
                }),
                bitmapResolution: 1,
                md5ext: '3696356a03a8d93831ab76a593515255.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: translator(messages.meow),
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 100,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        },
        M5:{
            isStage: false,
            isRobot: true,
            robotType: 'M5',
            name: "M5控制器",
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            costumes: [{
                assetId: '3696356a03a8d93831ab76a593515256',
                name: '造型1',
                bitmapResolution: 1,
                md5ext: '3696356a03a8d93831ab76a593515256.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: '声音1',
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 100,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        },
        C6: {
            isStage: false,
            isRobot: true,
            robotType: 'C6',
            name: translator(messages.C6, {
                index: 1
            }),
            variables: {},
            lists: {},
            broadcasts: {},
            blocks: {},
            currentCostume: 0,
            costumes: [{
                assetId: '3696356a03a8d93831ab76a593515257',
                name: translator(messages.costume, {
                    index: 1
                }),
                bitmapResolution: 1,
                md5ext: '3696356a03a8d93831ab76a593515257.svg',
                dataFormat: 'svg',
                rotationCenterX: 48,
                rotationCenterY: 50
            }],
            sounds: [{
                assetId: '83c36d806dc92327b9e7049a565c6bff',
                name: translator(messages.meow),
                dataFormat: 'wav',
                format: '',
                rate: 22050,
                sampleCount: 18688,
                md5ext: '83c36d806dc92327b9e7049a565c6bff.wav'
            }],
            volume: 100,
            visible: false,
            x: 0,
            y: 0,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: 'all around'
        }
    }
}


export default DefaultRobot
